/* eslint-disable max-len */
import { Grid } from '@mui/material';
import React, { memo, useEffect, useState } from 'react';
import FeedCreation from './FeedCreation';
import Connections from './Connections';
import FeedCards from './FeedCards';
import MyActivity from './Connections/Activity';
import DraftFeeds from './Draft';
import CelebrationCard from './CelebrationsEvents';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { feedRoutes } from '../..';
import IndividualFeed from './IndivisualFeed';

const LeftPart = (props) =>
{
	const { searchVal, selectedFilter, setSelectedFilter } = props;
	const { type } = useParams();
	const feedCard = [ 'bookmarks', 'popularfeeds', 'connections', 'feeds', 'pendingapproval' ]; // displaying feed list for these routes only
	const navigate = useNavigate();
	const [ connectionData, setConnectionData ] = useState<any>([]);
	const [ searchParams ] = useSearchParams();
	const paramsValue = searchParams.get('post');
	const [ feedConnectionData, setFeedConnectionData ] = useState<any>([]);

	useEffect(() =>
	{
		if ((type && !feedRoutes?.includes(type)) || (type === 'connections' && (!connectionData?.userId || !connectionData?.type)))
		{
			navigate('/news');
		}
	}, [ type, connectionData ]);

	return (
		<Grid container flexDirection={'column'}
			height={type === 'celebrationevents' ? 'var(--percent100)' : 'auto'}
			minHeight='var(--percent100)'
			flexWrap={'nowrap'} flex={'none'}
			pt={(window.location.pathname === '/news' && window.location.search === '') ? 0 : 2}
		>
			{[ 'myactivity' ]?.includes(type ?? '') &&
			<MyActivity
				searchVal={searchVal}
				selectedFilter={selectedFilter}
			/>}
			{[ 'draft' ]?.includes(type ?? '') && <DraftFeeds searchVal={searchVal} /> }
			{!type && !paramsValue &&
			<FeedCreation
				setSelectedFilter={setSelectedFilter}
				feedConnectionData={feedConnectionData}
			/> } {/* create feed popup */}
			{Boolean(!type || [ 'connections' ]?.includes(type ?? '')) && !paramsValue &&
			<Connections setConnection={setConnectionData} connectionData={connectionData} setSelectedFilter={setSelectedFilter} setFeedConnectionData={setFeedConnectionData} feedConnectionData={feedConnectionData}/>}
			{Boolean(!type || feedCard?.includes(type)) && !paramsValue &&
			<FeedCards
				key={type}
				requestT={connectionData ?? []}
				searchVal={searchVal}
				selectedFilter={selectedFilter}
			/>}
			{[ 'celebrationevents' ].includes(type ?? '') && <CelebrationCard /> }
			{Boolean(paramsValue) && <IndividualFeed postId={paramsValue}/>}
		</Grid>
	);
};

export default memo(LeftPart);